module.exports = __webpack_public_path__ + "img/20251014.640f36cb.jpg";